import { Component, OnInit, AfterViewInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'sidenav',
  templateUrl: './sidenav.component.html'
})
export class SideNavComponent implements OnInit{

  isDashboardActive: boolean = false;

  constructor(public route: ActivatedRoute, private router: Router, public globals: Globals) { }  

  ngOnInit(): void {
    if(this.router.url == "/" || this.router.url.indexOf("/dashboard") !== -1) {
      this.isDashboardActive = !this.isDashboardActive;
    } else {
      this.isDashboardActive = false;
    }
  }
}
